import { LoginMode } from '../../../../../../interfaces/src/lib/enums/index';
import { TokenExchangeResponse } from '../../../../../../interfaces/src/lib/interfaces/index';

export const TokenExchangeResponseMock: TokenExchangeResponse = {
  token: 'eyJhbGciOiJIUzI1NiIsIn',
  loginMode: LoginMode.FULL,
  name: 'Jonh',
  surname: 'Wich',
  dateOfBirth: '2024-05-10',
  countryOfResidence: 'GB',
  email: 'email@email.com',
};
